import { Amount } from "@/components";
import * as Domain from "@/domain";
import { colors } from "@/styles/colors";
import { Icon, Progress } from "@/ui";
import format from "date-fns/format";
import parse from "date-fns/parse";
import { FunctionComponent, ReactElement } from "react";
import styles from "./Debt.module.scss";
import { IDebtProps } from "./types";

export const Debt: FunctionComponent<IDebtProps> = (
  props: IDebtProps
): ReactElement<IDebtProps> => {
  const { debt, ...restProps } = props;

  return (
    <div {...restProps}>
      <div className="blockLine">
        <h2>{debt.name}</h2>
      </div>
      <div className="fullCard mainBlockBg targetAndDebtCard shadowCard marginBottom">
        <Progress.Bar
          backgroundColor={Domain.Color.schemas[debt.color].lightBackground}
          color={debt.color}
          total={debt.limitation}
          value={debt.balance}
        />
        <div className="smallCard marginBottom">
          <Icon
            backgroundColor={debt.color}
            className={styles.iconDefault}
            color={colors.palette.white}
            icon={debt.icon}
            size={32}
          />
          <div className="cardContent">
            <Amount
              className="cardContentValue"
              currency={debt.currency}
              value={debt.balance}
            />
            <Amount
              currency={debt.currency}
              value={debt.limitation}
              renderText={(formattedValue) => (
                <span className="cardContentLabel">{`из ${formattedValue}`}</span>
              )}
            />
          </div>
        </div>
        <ul className="btnGroupHorizontal">
          {debt.deadlineAt && (
            <li className="btnGroupHorizontalLi">
              <div className="btnDescription">
                {false && (
                  <span className="btnDescriptionLabel">
                    Осталось времени до погашения:
                  </span>
                )}
                <span className="btnDescriptionLabel">Вернуть до</span>
                {false && (
                  <span className="btnDescriptionValue">
                    20 дней и 12 часов
                  </span>
                )}
                <span className="btnDescriptionValue">
                  {format(
                    parse(debt.deadlineAt, "yyyy-MM-dd", new Date()),
                    "dd.MM.yyyy"
                  )}
                </span>
              </div>
            </li>
          )}
          {false && (
            <li className="btnGroupHorizontalLi">
              <a
                href="#"
                className="mainBtn"
                onClick={() => console.log("twoLevelModal(addIncome);")}
              >
                Погасить
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};
